import React from "react";
import { useSelector } from "react-redux";

import { i18, trb } from "@utilities";
import { SelectFormField, NumberFormField } from "@components/FormField/HookFormFields";
import { HalfWidthInputWrapper, StepperFormRow } from "@components";
import { selectClientSizeOptions } from "@redux";
import { numberFormat } from "@utilities";

export const ClientBasicBusinessIncome = ({ control }) => {
  const clientSizeOptions = useSelector(selectClientSizeOptions);

  return (
    <StepperFormRow>
      <HalfWidthInputWrapper>
        <NumberFormField
          control={control}
          format={numberFormat().currency}
          title={trb(i18.Labels.YearlyIncome)}
          name="clientBasicBusiness.0.data.yearlyIncome"
        />
      </HalfWidthInputWrapper>

      <HalfWidthInputWrapper>
        <NumberFormField
          control={control}
          title={trb(i18.Labels.BalAsst)}
          name="clientProfile.0.data.balAsst"
          format={numberFormat().currency}
        />
      </HalfWidthInputWrapper>

      <HalfWidthInputWrapper>
        <NumberFormField
          control={control}
          title={trb(i18.Labels.ClientEmployeeQty)}
          format={numberFormat().number}
          name="clientProfile.0.data.clientEmployeeQty"
        />
      </HalfWidthInputWrapper>

      <HalfWidthInputWrapper>
        <SelectFormField
          control={control}
          name="clientProfile.0.data.clientSize"
          title={trb(i18.Labels.ClientSize)}
          options={clientSizeOptions}
          optionsLabel="label"
          optionsValue="value"
          isSearchable
        />
      </HalfWidthInputWrapper>
    </StepperFormRow>
  );
};
